export const rejectError = (reason) => {
  let message = reason.response ? `Unexpected error ${reason.response.status}` : 'Unexpected error';
  if (reason.response && reason.response.data && reason.response.data.error) {
    message = reason.response.data.error.message;
  }
  return Promise.reject(message);
};

export const rejectErrorApiV2 = (result) => {
  let message = 'Unexpected error';
  if (result.data && result.data.error) {
    message = result.data.error.message;
  }
  return Promise.reject(message);
};
